// extracted by mini-css-extract-plugin
module.exports = {"PriceBlock":"PriceBlock_PriceBlock__efJK7"};